import { ChangeDetectionStrategy, Component, computed, EventEmitter, input, Output, Signal } from '@angular/core';
import { OverlayInputInterface } from 'countable@model';
import { LukaChatbotComponent } from '../luka-chatbot/luka-chatbot.component';

@Component({
  selector: 'app-luka-overlay',
  imports: [
    LukaChatbotComponent
  ],
  templateUrl: './luka-overlay.component.html',
  styleUrl: './luka-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LukaOverlayComponent {

  public overlayInput = input<OverlayInputInterface>(null);
  @Output() overlayAction: EventEmitter<any> = new EventEmitter<any>(true);
  public botInputs: Signal<OverlayInputInterface> = computed(() => {
    const inputs = this.overlayInput();
    return {...inputs} as OverlayInputInterface;
  });

  public emitAction(event: any) {
    this.overlayAction.emit(event);
  }

}
